import {
    GET_GCP_THRESHOLD_SUCCESS,
    GET_GCP_THRESHOLD_FAIL,
    GET_GCP_THRESHOLD,
    PUT_GCP_THRESHOLD,
    PUT_GCP_THRESHOLD_FAIL,
    PUT_GCP_THRESHOLD_SUCCESS,
    POST_DISABLE_GCP_THRESHOLD_ALERTS_FAIL,
    POST_DISABLE_GCP_THRESHOLD_ALERTS_SUCCESS,
    POST_DISABLE_GCP_THRESHOLD_ALERTS,
    POST_ENABLE_GCP_THRESHOLD_ALERTS,
    POST_ENABLE_GCP_THRESHOLD_ALERTS_FAIL,
    POST_ENABLE_GCP_THRESHOLD_ALERTS_SUCCESS
} from "./actionTypes";

export const getGCPThreshold = (data) => ({
    type: GET_GCP_THRESHOLD,
    payload: data
})

export const getGCPThresholdSuccess = gcp_threshold => ({
    type: GET_GCP_THRESHOLD_SUCCESS,
    payload: gcp_threshold,
})

export const getGCPThresholdFail = error => ({
    type: GET_GCP_THRESHOLD_FAIL,
    payload: error,
})

export const putGCPThreshold = (data) => ({
    type: PUT_GCP_THRESHOLD,
    payload: { data }
})

export const putGCPThresholdSuccess = (gcp_threshold) => ({
    type: PUT_GCP_THRESHOLD_SUCCESS,
    payload: { gcp_threshold }
})

export const putGCPThresholdFail = error => ({
    type: PUT_GCP_THRESHOLD_FAIL,
    payload: error,
})

export const postDisableGCPThresholdAlerts = (data) => ({
    type: POST_DISABLE_GCP_THRESHOLD_ALERTS,
    payload: { data }
})

export const postEnableGCPThresholdAlerts = (data) => ({
    type: POST_ENABLE_GCP_THRESHOLD_ALERTS,
    payload: { data }
})

export const postEnableGCPThresholdAlertsSuccess = gcp_threshold => ({
    type: POST_ENABLE_GCP_THRESHOLD_ALERTS_SUCCESS,
    payload: gcp_threshold,
})

export const postDisableGCPThresholdAlertsSuccess = gcp_threshold => ({
    type: POST_DISABLE_GCP_THRESHOLD_ALERTS_SUCCESS,
    payload: gcp_threshold,
})

export const postEnableGCPThresholdAlertsFail = error => ({
    type: POST_ENABLE_GCP_THRESHOLD_ALERTS_FAIL,
    payload: error,
})

export const postDisableGCPThresholdAlertsFail = error => ({
    type: POST_DISABLE_GCP_THRESHOLD_ALERTS_FAIL,
    payload: error,
})